// @flow
import React from 'react';
import type { LanguageType, ApplicationType } from './flowTypes';

const defaultApplicationContext : ApplicationType = {
  appFolder: '',
  language: 'en',
  setLanguage: (language: LanguageType) : void => {},
};
const ApplicationContext = React.createContext(defaultApplicationContext);
export default ApplicationContext;



// WEBPACK FOOTER //
// ./src/application/ApplicationContext.js